// Angular
import { Component, ViewEncapsulation, OnInit, OnChanges, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../store';

// Actions
import * as ResetPassActions from '../../store/access/resetPass/resetPass.actions';
import * as RouterActions from '../../store/router/router.actions';

import { TranslateService } from '@ngx-translate/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-resetpass',
    templateUrl: './resetPass.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ResetPassComponent implements OnInit, OnChanges {
    @Input() bannerPromo;
    @Input() logo;

    data: any = { password: '', token: '' };
    password = '';
    passwordRepeat = '';

    typeOKMsg: boolean;
    msg: string;
    loading: boolean;
    sendIt: boolean;

    bannerPromoImg: SafeUrl = '';
    logoUrl: SafeUrl = '';
    bannerPromoExists = false;

    ngOnChanges() {
        // Get background
        if (this.bannerPromo) {
            this.bannerPromoImg = this.sanitize.bypassSecurityTrustUrl(this.bannerPromo);
        }

        if (this.logo) {
            this.logoUrl = this.sanitize.bypassSecurityTrustUrl(this.logo);
        }
    }

    constructor(
        private activatedRoute: ActivatedRoute,
        private store: Store<AppState>,
        private translate: TranslateService,
        private sanitize: DomSanitizer
    ) {}

    ngOnInit() {
        // Get URL Token
        this.data.token = this.activatedRoute.snapshot.params['token'];

        this.subscribeResetPass();
    }

    subscribeResetPass(): void {
        this.store
            .select((state) => state.resetPass)
            .subscribe((res) => {
                // console.log("[ResetPassComponent]", {res});
                if (res && res.result) {
                    if (res.result.result == 0 && res.result.value[0].CODIGO >= 0) {
                        // this.store.dispatch(new RouterActions.Go({
                        //     path: ['login']
                        // }));
                        this.showMsg(res.result.value[0].MENSAJE, true);
                        this.sendIt = true;
                    } else if (res.result.value) {
                        this.showMsg(res.result.value[0].MENSAJE, false);
                    }
                } else {
                    if (res.error) {
                        this.showMsg(res.error.value, false);
                    }
                }

                this.loading = false;
            });
    }

    clickResetPass() {
        this.loading = true;
        if (this.isValidForm()) {
            this.resetPass();
        } else {
            this.loading = false;
        }
    }

    isValidForm(): boolean {
        if (!this.password) {
            this.showMsg('Debe rellenar el campo contraseña', false);
            return false;
        } else if (this.password !== this.passwordRepeat) {
            this.showMsg('Las contraseñas no coinciden', false);
            return false;
        }

        return true;
    }

    resetPass() {
        this.showMsg('', true);
        this.data.password = this.password;
        this.store.dispatch(new ResetPassActions.DoReset(this.data));
    }

    showMsg(msg: string, success: boolean) {
        this.msg = msg;
        this.typeOKMsg = success;
    }

    backToLogin(ev) {
        ev.preventDefault();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['login'],
            })
        );
    }

    goRegister(ev) {
        ev.preventDefault();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['signup'],
            })
        );
    }

    goProducts(ev) {
        ev.preventDefault();

        this.store.dispatch(
            new RouterActions.Go({
                path: ['dashboard/products'],
            })
        );
    }

    bannerPromoFail() {
        this.bannerPromoExists = false;
    }

    bannerPromoOk() {
        this.bannerPromoExists = true;
    }
}
